interface Props {
  children: JSX.Element;
}

export default function Cardano({ children }: Props) {
  return <>{children}</>;
}
